import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "components/buttons";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { deleteOcurrenceSource } from "../../../../services/commonService";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose && (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function DialogDeleteOcurrenceSource({
  intl,
  contractId,
  item,
  open,
  handleClose,
  eventType,
}) {


  //DELETE Ocurrence Source
  const handleSetLessOcurrenceSourceItem = response => {
    handleClose();
  };

  const handleDeleteOcurrenceSource = () => {
    deleteOcurrenceSource(
        {
          contract_id: contractId,
          event_type_id: eventType.id,
          occurrence_source_name: item,
        },
        handleSetLessOcurrenceSourceItem,
    );
  };


  return (
    <div>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {intl.formatMessage({ id: "contract.ocurrenceSource.delete" })}
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>{intl.formatMessage({ id: "contract.ocurrenceSource.delete.info" })}</Typography>
          {item}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            {intl.formatMessage({ id: "common.cancel" })}
          </Button>
          <Button autoFocus onClick={handleDeleteOcurrenceSource} color="primary">
            {intl.formatMessage({ id: "common.accept" })}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
